import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { HealthMonitoringService } from "../services/health-monitoring.service";

@Component({
  selector: 'app-health-monitoring-renderer',
  template: `
    <div class="img-container" (click)="onClickHandler($event)">
    <collab-comp-img-generator imageType="image" imageAltText="Subscribe"
    imgUrl="/assets/Subscribe.svg"></collab-comp-img-generator>
    </div>
  `,
  styles: [`
    .img-container {
      display: flex;
      align-items: center;
      margin-top: 10px;
      cursor: pointer;
      color: #3D3DB8;
      width: 2px;
    }
  `]
})
export class HealthMonitoringActionsButtonRendererComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;

  constructor(private healthMonitoriningService: HealthMonitoringService) { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  onClickHandler(event: Event): void {
    event.stopPropagation();
    this.healthMonitoriningService.triggerAction(this.params.data);
    this.healthMonitoriningService.clearEmail();

  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}